/**
 * Encoding helpers without Buffer, atob or TextEncoder, so the package runs unchanged in Node,
 * browsers, React Native (Hermes) and any other JavaScript engine.
 */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const LOOKUP = {};
for (let i = 0; i < ALPHABET.length; i++)
    LOOKUP[ALPHABET[i]] = i;
/** base64url (RFC 4648 section 5, no padding). Returns null for any invalid character. */
export function base64urlDecode(text) {
    const s = text.replace(/=+$/, '');
    if (s.length % 4 === 1)
        return null;
    const out = new Uint8Array(Math.floor((s.length * 3) / 4));
    let bits = 0;
    let value = 0;
    let o = 0;
    for (const ch of s) {
        const v = LOOKUP[ch];
        if (v === undefined)
            return null;
        value = (value << 6) | v;
        bits += 6;
        if (bits >= 8) {
            bits -= 8;
            out[o++] = (value >> bits) & 0xff;
        }
    }
    return out;
}
export function base64urlEncode(bytes) {
    let out = '';
    let i = 0;
    for (; i + 2 < bytes.length; i += 3) {
        const n = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        out += ALPHABET[(n >> 18) & 63] + ALPHABET[(n >> 12) & 63] + ALPHABET[(n >> 6) & 63] + ALPHABET[n & 63];
    }
    const rest = bytes.length - i;
    if (rest === 1) {
        const n = bytes[i] << 16;
        out += ALPHABET[(n >> 18) & 63] + ALPHABET[(n >> 12) & 63];
    }
    else if (rest === 2) {
        const n = (bytes[i] << 16) | (bytes[i + 1] << 8);
        out += ALPHABET[(n >> 18) & 63] + ALPHABET[(n >> 12) & 63] + ALPHABET[(n >> 6) & 63];
    }
    return out;
}
/** Strict UTF-8 decoding; null for malformed input. */
export function utf8Decode(bytes) {
    let out = '';
    for (let i = 0; i < bytes.length;) {
        const b = bytes[i];
        let cp;
        let extra;
        if (b < 0x80) {
            cp = b;
            extra = 0;
        }
        else if (b >= 0xc2 && b < 0xe0) {
            cp = b & 0x1f;
            extra = 1;
        }
        else if (b >= 0xe0 && b < 0xf0) {
            cp = b & 0x0f;
            extra = 2;
        }
        else if (b >= 0xf0 && b < 0xf5) {
            cp = b & 0x07;
            extra = 3;
        }
        else
            return null;
        // A truncated sequence reads `undefined` below and is rejected.
        for (let k = 1; k <= extra; k++) {
            const c = bytes[i + k];
            if (c === undefined || (c & 0xc0) !== 0x80)
                return null;
            cp = (cp << 6) | (c & 0x3f);
        }
        if ((extra === 2 && (cp < 0x800 || (cp >= 0xd800 && cp <= 0xdfff))) || (extra === 3 && (cp < 0x10000 || cp > 0x10ffff)))
            return null;
        out += String.fromCodePoint(cp);
        i += extra + 1;
    }
    return out;
}
export function utf8Encode(text) {
    const out = [];
    for (const ch of text) {
        const cp = ch.codePointAt(0);
        if (cp < 0x80)
            out.push(cp);
        else if (cp < 0x800)
            out.push(0xc0 | (cp >> 6), 0x80 | (cp & 63));
        else if (cp < 0x10000)
            out.push(0xe0 | (cp >> 12), 0x80 | ((cp >> 6) & 63), 0x80 | (cp & 63));
        else
            out.push(0xf0 | (cp >> 18), 0x80 | ((cp >> 12) & 63), 0x80 | ((cp >> 6) & 63), 0x80 | (cp & 63));
    }
    return Uint8Array.from(out);
}
//# sourceMappingURL=bytes.js.map